import { computed, Directive, input } from '@angular/core';
import { hlm } from '@spartan-ng/helm/utils';
import { ClassValue } from 'clsx';

@Directive({
  selector: 'div[cardItem]',
  host: {
    'data-slot': 'item',
    '[class]': '_computedClass()',
  },
})
export class CardItem {
  public readonly userClass = input<ClassValue>('', { alias: 'class' });

  protected readonly _computedClass = computed(() =>
    hlm(
      'py-xxs px-xs bg-background-underground border-stroke-neutral-light hover:bg-background-underground-2 flex items-center rounded-sm border',
      this.userClass(),
    ),
  );
}
